import { EZChatControllerNew } from "@axl/ez-chat-for-school";
import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from "react";

type ChatContextType = {
  chatController: EZChatControllerNew | null;
  setChatController: (controller: EZChatControllerNew | null) => void;
  isChatInited: boolean;
  unreadCount: number;
};

const ChatContext = createContext<ChatContextType>({} as ChatContextType);

export const ChatProvider: FC<PropsWithChildren> = ({ children }) => {
  const [chatController, setChatController] =
    useState<EZChatControllerNew | null>(null);
  const [isChatInited, setChatInited] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!chatController) return;
    const handler = () => setChatInited(true);
    (chatController as any).onInited.on(handler);
    return () => (chatController as any).onInited.off(handler);
  }, [chatController]);

  useEffect(() => {
    if (!chatController || !isChatInited) return;
    const handler = (count: number) => setUnreadCount(count)
    chatController.onUnreadCountChanged.on(handler);
    return () => chatController.onUnreadCountChanged.off(handler);
  }, [chatController, isChatInited]);

  const ctxValue = {
    chatController,
    setChatController,
    isChatInited,
    unreadCount,
  };

  return (
    <ChatContext.Provider value={ctxValue}>{children}</ChatContext.Provider>
  );
};

export const useChat = () => useContext(ChatContext);
